import React from 'react'
import { Badge } from '@mc/design-system'
import { HeaderActionProps } from '../../../../types/headerActionProps'
import { HeaderCell } from '../HeaderCell'
import { Info } from '../Info'
import { SelectButton, SelectButtonProps } from '../SelectButton'
import classes from '../../Table.module.scss'

type ActionContentProps = HeaderActionProps & SelectButtonProps

export const ActionContent = ({
  isSelected,
  onClick,
  badge,
  badgeKind,
  description,
  children,
  spacing = 4,
  ...props
}: ActionContentProps) => (
  <HeaderCell isSelected={isSelected} spacing={spacing}>
    {badge && (
      <Badge kind={badgeKind} className={classes.badge}>
        {badge}
      </Badge>
    )}
    {!!description && <Info info={description} />}
    <SelectButton isSelected={isSelected} onClick={onClick} {...props} />
    {children}
  </HeaderCell>
)
